import { userStore } from "../ducks/user";
import { wsConnectionStore } from "../ducks/wsConnection";
import { connectToWebSocket, useLongPolling } from "./websocket";
import { routeIncommingMessage } from "./wsInRoutes";
import { GamePlayWs } from "./wsOutRoutes";

let longPollingRequestTimeout: NodeJS.Timeout;

function setLongPollingRequestTimeout(username: string, sessionId: string) {
  clearTimeout(longPollingRequestTimeout);
  longPollingRequestTimeout = setTimeout(() => {
    longPollingGetRequest(username, sessionId);
    import("../ducks/gamePlay").then(({ gamePlayStore }) => {
      const { gameId, turns, moves } = gamePlayStore.getState();
      GamePlayWs.sendGameSync(gameId, turns, moves);
    });
  }, 30000);
}

export async function longPollingGetRequest(
  username: string,
  sessionId: string
) {
  const { longPollingUrl } = wsConnectionStore.getState();

  setLongPollingRequestTimeout(username, sessionId);

  try {
    const response = await fetch(
      `${longPollingUrl}/long-polling?username=${username}&sessionId=${sessionId}`
    );
    clearTimeout(longPollingRequestTimeout);

    if (response.ok == false) {
      console.log("error", response.status);
      connectToWebSocket();
      return;
    }
    const data = await response.json();

    if (data?.error) {
      connectToWebSocket();
      return;
    }

    if (data?.cmd && data.cmd != "NO_DATA") {
      routeIncommingMessage(data);
    }

    if (useLongPolling) {
      longPollingGetRequest(username, sessionId);
    }

    if (data?.cmd == "NO_DATA") {
      setTimeout(() => {
        import("../ducks/gamePlay").then(({ gamePlayStore }) => {
          const { gameId, turns, moves } = gamePlayStore.getState();
          GamePlayWs.sendGameSync(gameId, turns, moves);
        });
      }, 200);
    }
  } catch (e) {
    console.log(e);
  }
}

export async function longPollingPostRequest(message: object) {
  const username = userStore.getState().username;
  const sessionId = sessionStorage.getItem("sessionId");
  const { longPollingUrl } = wsConnectionStore.getState();
  try {
    const response = await fetch(`${longPollingUrl}/command`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        sessionId,
        message,
      }),
    });

    if (!response.ok) {
      return;
    }
  } catch (e) {
    console.log(e);
  }
}
